/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkstreamHeadcountDataResponse } from '../models/WorkstreamHeadcountDataResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkstreamHeadcountDataService {

    /**
     * Get Workstream Headcount Data
     * @param workstreamId
     * @param timeframe H1 FY26 or H2 FY26 planning root whose staffing is rolled up.
     * @returns WorkstreamHeadcountDataResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamHeadcountDataApiV1WorkstreamWorkstreamIdHeadcountDataGet(
        workstreamId: number,
        timeframe: string = '',
    ): CancelablePromise<WorkstreamHeadcountDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{workstream_id}/headcount-data',
            path: {
                'workstream_id': workstreamId,
            },
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
